Vendd.Scripts.load(function () {

    var $form = $('.x-test-drive-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    var submitClicked = false;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    importEmailForRegistration();

    initFormsDatePicker();

    formData = {
        "firstName": "",
        "lastName": "",
        "phone": "",
        "email": "",
        "brand": "",
        "model": "",
        "area": "",
        "message": "",
        "type": "",
        "date": ""
        // "policyEmail": true,
        // "policyPhone": true,
        // "policySms": true
    };

    form.show = function (bool) {
        if (bool) {
            $form.addClass('visible');
            $('input:first', $form).focus();
        } else {
            $form.removeClass('visible');
        }
    };


    form.resetDropdowns = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var element = $('select[name="area"]', $form);

            element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
            element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

            element = $('select[name="brand"]', $form);
            element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
            element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

            element = $('select[name="model"]', $form);
            element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
            element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

            var recreateSelect = "<select class=\"makesDropdown\" name=\"brand\" id=\"makesDropdown\" disabled> </select>";
            $('.makesDropdownDiv', $form).html(recreateSelect);
            $('.makesDropdown').sSelect();

            recreateSelect = "<select class=\"modelsDropdown\" name=\"model\" id=\"modelsDropdown\" disabled> </select>";
            $('.modelsDropdownDiv', $form).html(recreateSelect);
            $('.modelsDropdown').sSelect();

            var branch = $(".branchesDropdown", $form);
            branch.val("");
            branch.change();

            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        }
    };

    form.validateBranch = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var branchValue = formData.area;

            var element = $('select[name="area"]', $form);

            if (branchValue !== "" && branchValue !== null && branchValue !== undefined) {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

                return true;
            }
            else {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').addClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').addClass("error");

                return false;
            }
        }
    };

    form.updateBranch = function (branchValue) {
        if ($("#apiCallSuccessful").val() === "success") {
            //$('input[name="brand"]', $form).val(brandText);
            formData.area = branchValue;
            if (submitClicked)
                form.validateBranch();
        }
    };

    form.updateBranchText = function (branchTextValue) {
        formData.areaText = branchTextValue;
    };

    form.validateBrand = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var brandValue = formData.brand;

            var element = $('select[name="brand"]', $form);

            if (brandValue !== "" && brandValue !== null && brandValue !== undefined) {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

                return true;
            }
            else {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').addClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').addClass("error");

                return false;
            }
        }
    };

    form.updateBrand = function (brandValue) {
        if ($("#apiCallSuccessful").val() === "success") {
            //$('input[name="brand"]', $form).val(brandText);
            formData.brand = brandValue;
            if (submitClicked)
                form.validateBrand();
        }else {
            $('input[name="brand"]', $form).val(brandValue);
        }
    };

    form.updateBrandText = function (brandTextValue) {
        formData.brandText = brandTextValue;
    };

    form.validateModel = function () {
        if ($("#apiCallSuccessful").val() === "success") {
            var modelValue = formData.model;

            var element = $('select[name="model"]', $form);

            if (modelValue !== "" && modelValue !== null && modelValue !== undefined) {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').removeClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').removeClass("error");

                return true;
            }
            else {
                element.closest(".form-row").children('.input-wrapper, .textarea-wrapper, .select-wrapper, .validator').addClass("error");
                element.closest('.form-row').children('.error-wrapper').children('.validator').addClass("error");

                return false;
            }
        }
    };

    form.updateModel = function (modelValue) {
        if ($("#apiCallSuccessful").val() === "success") {
            //$('input[name="brand"]', $form).val(brandText);
            formData.model = modelValue;
            if (submitClicked)
                form.validateModel();
        }else {
            $('input[name="model"]', $form).val(modelValue);
        }
    };

    form.updateModelText = function (modelTextValue) {
        formData.modelText = modelTextValue;
    };

    form.updateExternalLink = function (externalLink) {
        if (externalLink !== undefined && externalLink != '') {
            $('.external-link a', $form).attr('href', externalLink).html(externalLink);
            $('.external-link', $form).show();
        }
    };

    form.updateType = function (formType, formExternalService) {
        formData.type = formType;
        //Switch to external service for notification sending
        form.updateExternalService(formExternalService);
    };

    form.updateExternalService = function (formExternalService) {
        //Switch to external service for notification sending
        if (formExternalService == 'true')
            formData.externalService = 1;
        else
            formData.externalService = 0;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.isHover = function () {
        return $form.hasClass('hovered');
    };

    form.onSuccess = function (envelope) {
        if (!$form.hasClass('x-loading'))
            return;

        form.loading(false);

        var notificationSent;

        if (formData.externalService) {
            notificationSent = 1;
        } else {
            notificationSent = envelope.message.data.MailSent;
        }

        if (notificationSent) {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();
        }

        if ($(window).width() < 480) {
            var toScroll = $('.form-title-container', $form).offset().top - 20;
            $('html, body').animate({ scrollTop: toScroll }, 100, 'swing');
        }
        
        var querystring = '?form=success';
        window.history.pushState({}, '', querystring);
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        var $errorElem = $('.js-error', $form);

        $errorElem.show();

        if ($(window).width() < 480) {
            var toScroll = $errorElem.offset().top - 20;
            $('html, body').animate({ scrollTop: toScroll }, 100, 'swing');
        }
    };

    form.submit = function () {
        form.loading(true);

        form.trackEvent(formData);
       
        if (formData.externalService) {
            //form.sendNotificationExtService();
            form.CreateLead();
        } else {
            form.sendNotification();
        }

    };

    form.trackEvent = function (data) {
        var eventCategory = '';
        if (data.type == 'bookService') {
            eventCategory = 'ServiceForm';
        } else if (data.type == 'testDrive') {
            eventCategory = 'TestDriveForm';
        }

        if (window.ga && ga.create) {
            if (eventCategory !== '') {
                ga('send', {
                    hitType: 'event',
                    eventCategory: eventCategory,
                    eventAction: 'Submit',
                    dimension1: data.brand,
                    dimension2: data.model
                });
            }
        }
    };

    form.CreateLead = function () {
        Vendd.MessageBus.publishAsync('CreateLead', new Vendd.SubmitToExternalEndpoint.Messages.CreateLead(formData));
    };

    form.sendNotificationExtService = function () {
        console.log('Switched to alternative method for form sending, setup the method and then remove the log');
        var notificationTypeCode, recieverEmail, language;

        recieverEmail = $form.attr('data-email-reciever');
        language = $form.attr('data-lang-code');

        if (formData.type === 'testDrive') {
            notificationTypeCode = 'Custom-Form-Test-Drive';
        } else if (formData.type === 'bookService') {
            notificationTypeCode = 'Custom-Form-Service';
        }

        var params = {
            FirstName: formData.firstName,
            LastName: formData.lastName,
            Phone: formData.phone,
            Email: formData.email,
            Brand: formData.brand,
            Model: formData.model,
            Area: formData.area,
            Date: formData.date,
            Message: formData.message
            // PolicyEmail: formData.policyEmail,
            // PolicyPhone: formData.policyPhone,
            // PolicySMS: formData.policySms,
        };

        var model = {
            toemail: (LhApp.IsDevEnvironment) ? recieverEmail : formData.email,
            fromemail: formData.email,
            relatedObjectid: 10,
            langCode: language ? language : 'el',
            notificationTemplateCode: notificationTypeCode,
            param: params
        };

        $.ajax({
            type: "POST",
            url: '',
            cache: false,
            dataType: 'json',
            data: {},
            statusCode: {
                200: function (response) {
                    form.onSuccess();
                },
                404: function (response) {
                    form.onFailure();
                },
                500: function (response) {
                    form.onFailure();
                }
            }
        });
    };

    form.sendNotification = function () {
        var notificationTypeCode, recieverEmail, language;

        recieverEmail = $form.attr('data-email-reciever');
        language = $form.attr('data-lang-code');

        if (formData.type === 'testDrive') {
            notificationTypeCode = 'Custom-Form-Test-Drive';
        } else if (formData.type === 'bookService') {
            notificationTypeCode = 'Custom-Form-Service';
        }

        var params = {
            FirstName: formData.firstName,
            LastName: formData.lastName,
            Phone: formData.phone,
            Email: formData.email,
            Brand: formData.brand,
            Model: formData.model,
            Area: formData.area,
            Date: formData.date,
            Message: formData.message
            // PolicyEmail: formData.policyEmail,
            // PolicyPhone: formData.policyPhone,
            // PolicySMS: formData.policySms,
        };

        var model = {
            toemail: (LhApp.IsDevEnvironment) ? recieverEmail : formData.email,
            fromemail: formData.email,
            relatedObjectid: 10,
            langCode: language ? language : 'el',
            notificationTemplateCode: notificationTypeCode,
            param: params
        };

        Vendd.MessageBus.publishAsync('CustomForm', new Vendd.CustomForms.Messages.SendNotification(model));

    };

    form.reset = function () {
        submitClicked = false;

        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();
        $('.external-link', $form).hide();

        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="email"]', $form).val("");
        //$('input[name="brand"]', $form).val("");
        //$('input[name="area"]', $form).val("");
        $('select[name="serviceType"]', $form).val("_").parent().removeClass('selected');
        //$('select[name="area"]', $form).val("_").parent().removeClass('selected');
        //$('input[name="model"]', $form).val("");
        $('input[name="date"]', $form).val("");
        $('input[name="message"]', $form).val("");
        $('#email').prop('checked', true);
        $('#phone').prop('checked', true);
        $('#sms').prop('checked', true);

        if ($("#apiCallSuccessful").val() === "success") {
            formData = {
                "firstName": "",
                "lastName": "",
                "phone": "",
                "email": "",
                //"brand": "",
                //"model": "",
                //"area": "",
                "message": "",
                "type": "",
                "date": "",
                "brandText": "",
                "modelText": "",
                "areaText": ""
                // "policyEmail": true,
                // "policyPhone": true,
                // "policySms": true,
            };
        }
        else {
            formData = {
                "firstName": "",
                "lastName": "",
                "phone": "",
                "email": "",
                "brand": "",
                "model": "",
                "area": "",
                "message": "",
                "type": "",
                "date": "",
                "brandText": "",
                "modelText": "",
                "areaText": ""
                // "policyEmail": true,
                // "policyPhone": true,
                // "policySms": true,
            };

            $('input[name="brand"]', $form).val("");
            $('input[name="model"]', $form).val("");
            $('select[name="area"]', $form).val("");
            $('select[name="area"]', $form).change();
        }

        rf.reset();
        if ($("#apiCallSuccessful").val() === "success") {
            form.resetDropdowns();
        }
    };

    form.handleErrors = function () {
        var $errorWrappers = $('.validator', $form);
        var emailError = false;
        $.each($errorWrappers, function (i, wrapper) {

            var $this = $(wrapper);
            if ($this.hasClass('error')) {
                if ($this.hasClass('email-required') || $this.hasClass('email-invalid')) {
                    if (!emailError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').addClass('error');
                        emailError = true;
                    }
                } else {
                    $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').addClass('error');
                }

            } else {
                if ($this.hasClass('email-required') || $this.hasClass('email-invalid')) {
                    if (!emailError) {
                        $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').removeClass('error');
                    }
                } else {
                    $this.closest('.form-row').children('.input-wrapper, .textarea-wrapper, .select-wrapper').removeClass('error');
                }

            }
        });

        if ($(window).width() < 480) {
            var errorElem = $('.error:first', $form);
            if (errorElem.length > 0) {
                setTimeout(function () {
                    var toScroll = $('.error:first', $form).offset().top - 30;
                    $('html, body').animate({ scrollTop: toScroll }, 100, 'swing');
                }, 1500);

            }

        }
    };

    var valOpts = {
        firstName: {
            required: 'firstname-required'
        },
        lastName: {
            required: 'lastname-required'
        },
        phone: {
            required: 'phone-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        },
        date: {
            required: 'date-required'
        }
    };

    $("#apiCallSuccessful").change(function () {

        if ($("#apiCallSuccessful").val() === "success") {

            rf.removeField("area");
            rf.removeField("brand");
            rf.removeField("model");

            $('#serviceType', $form).sSelect().change(function () {
                var $this = $(this);
                var fieldName = $this.attr('name');
                if ($this.val() !== '') {
                    formData[fieldName] = $this.val();
                    $this.parent().addClass('selected');
                }

                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                form.handleErrors($('.validator', $(this).parents('.form-row')));
            });
        }
        else {
            valOpts['area'] = {
                required: 'area-required'
            };
            valOpts['model'] = {
                required: 'model-required'
            };
            valOpts['brand'] = {
                required: 'brand-required'
            };
            $('select', $form).sSelect().change(function () {
                var $this = $(this);
                var fieldName = $this.attr('name');
                if ($this.val() !== '') {
                    formData[fieldName] = $this.val();
                    $this.parent().addClass('selected');
                }

                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                form.handleErrors($('.validator', $(this).parents('.form-row')));
            });
        }
    });


    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $form.on('click', '.js-submit-button', function (e) {
        submitClicked = true;
        var validateBranch = true;
        var validateBrand = true;
        var validateModel = true;

        if ($("#apiCallSuccessful").val() === "success") {
            validateBranch = form.validateBranch();
            validateBrand = form.validateBrand();
            validateModel = form.validateModel();
        }

        valOpts = $form.validationEngine();
        $form.validationEngine(valOpts);
        rf = $form.data('validationEngine');

        e.preventDefault();
        e.stopPropagation();

        var val1 = rf.validate();

        if (val1 && validateBranch && validateBrand && validateModel) {
            form.submit();
        } else {
            form.handleErrors();
        }
    });



    $form.on('keyup', 'input[name], textarea[name]', function (e) {

        if (e.keyCode === 13) {
            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();
        rf = $form.data('validationEngine');
        rf.validate(fieldName);
        form.handleErrors();
    });

    $form.on('click', 'input[type="checkbox"]', function (e) {
        policy = $(this).data('policy');
        if ($(this).is(':checked')) {
            formData[policy] = true;
        }
        else {
            formData[policy] = false;
        }
    });

    $form.hover(
        function (e) { $(this).addClass('hovered'); },
        function (e) { $(this).removeClass('hovered'); }
    );


    $('input', $form).focus(
        function () {
            $(this).parent('div').addClass('focus');
        }).blur(
            function () {
                $(this).parent('div').removeClass('focus');
            });

    $('textarea', $form).focus(
        function () {
            $(this).parent('div').addClass('focus');
        }).blur(
            function () {
                $(this).parent('div').removeClass('focus');
            });


    $(document).mouseup(function (e) {
        var container = $(".x-form, .xdsoft_datetimepicker");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            form.show(false);
        }
    });

    function initFormsDatePicker() {
        $('#datetimepickerTestDrive').datetimepicker({
            minDate: 0,
            disabledWeekDays: [0, 6],
            allowTimes: [
                '09:00', '10:00', '11:00', '12:00',
                '13:00', '14:00', '15:00', '16:00',
                '17:00', '18:00', '19:00', '20:00'
            ],
            onChangeDateTime: function (dp, $input) {
                formData.date = $input.val();
                $input.keyup();
            }
        });
        var current_language = $('html').attr('lang');
        $.datetimepicker.setLocale(current_language);
    }

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SendNotificationSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SendNotificationFailure, form, form.onFailure);

    Vendd.MessageBus.subscribe(Vendd.SubmitToExternalEndpoint.Messages.CreateLeadSuccess, form, function (envelope) {
        var response = envelope.message.data;
        if (response) {
            form.onSuccess();
        } else {
            form.onFailure();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.SubmitToExternalEndpoint.Messages.CreateLeadFailure, form, function (envelope) {
        form.onFailure();
    });
});